import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";

export interface IAlertStateSlice {
  alertFilter: IAlertFilterState & IDateFilterState;
  clinicalAlertFilter: IAlertFilterState & {
    floors?: number[];
  } & IDateFilterState;
  chimeRooms: (string | undefined)[];
  escalationChimeRooms: (string | undefined)[];
  flagChimeRooms: (string | undefined)[];
  openEscalations: {
    alertId: string;
    residentId: string;
    file?: string;
    viewType: number;
    isNotEscalation?: boolean;
  }[];
}

const name = "resident";

export const initialState: IAlertStateSlice = {
  alertFilter: {
    levels: [1, 2, 3],
    consent: ["1", "2"],
    read: true,
    unread: true,
    date: 1,
    customDate: null,
  },
  clinicalAlertFilter: {
    levels: [1, 2, 3],
    consent: ["1", "2"],
    read: true,
    unread: true,
    date: 0,
    floors: [],
    customDate: null,
  },
  chimeRooms: [],
  escalationChimeRooms: [],
  flagChimeRooms: [],
  openEscalations: [],
};

export const alertSlice = createSlice({
  name,
  initialState,
  reducers: {
    setAlertFilter(
      state,
      action: PayloadAction<Partial<IAlertStateSlice["alertFilter"]>>
    ) {
      state.alertFilter = { ...state.alertFilter, ...action.payload };
    },

    setClinicalAlertFilter(
      state,
      action: PayloadAction<Partial<IAlertStateSlice["clinicalAlertFilter"]>>
    ) {
      state.clinicalAlertFilter = {
        ...state.clinicalAlertFilter,
        ...action.payload,
      };
    },

    setAlertState: (
      state,
      action: PayloadAction<Partial<IAlertStateSlice>>
    ) => ({
      ...state,
      ...action.payload,
    }),

    setChimeRooms(
      state,
      action: PayloadAction<Partial<IAlertStateSlice["chimeRooms"]>>
    ) {
      state.chimeRooms = [...action.payload];
    },

    setEscalationChimeRooms(
      state,
      action: PayloadAction<Partial<IAlertStateSlice["escalationChimeRooms"]>>
    ) {
      state.escalationChimeRooms = [...action.payload];
    },

    setFlagChimeRooms(
      state,
      action: PayloadAction<Partial<IAlertStateSlice["flagChimeRooms"]>>
    ) {
      state.flagChimeRooms = [...action.payload];
    },
    setOpenEscalation(
      state,
      action: PayloadAction<IAlertStateSlice["openEscalations"][0]>
    ) {
      state.openEscalations = [...state.openEscalations, action.payload];
    },
    removeOpenEscalation(state, action: PayloadAction<string>) {
      state.openEscalations = state.openEscalations.filter(
        (item) => item.residentId !== action.payload
      );
    },
    setOpenEscalationViewType(state, action: PayloadAction<string>) {
      const parseState = state.openEscalations.map((item) => {
        console.log(item.residentId, action.payload, +!item.viewType);

        return {
          ...item,
          viewType:
            item.residentId === action.payload
              ? +!item.viewType
              : item.viewType,
        };
      });

      state.openEscalations = parseState;
    },
  },
});

export const {
  setAlertFilter,
  setClinicalAlertFilter,
  setAlertState,
  setChimeRooms,
  setEscalationChimeRooms,
  setFlagChimeRooms,
  setOpenEscalation,
  removeOpenEscalation,
  setOpenEscalationViewType,
} = alertSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["alertFilter", "clinicalAlertFilter"],
  },
  alertSlice.reducer
);

export default persistedReducer;
